import React, {useEffect, useState, useContext, useCallback} from 'react'
import {FormControl, TextField} from '@material-ui/core'
import _ from 'lodash'
import {ReservationContext} from './../../../../context/Reservation'

import useGetConfigurationReducer from '../../../../state/reservation/get-configuration/reducer'
import {getConfiguration} from '../../../../state/reservation/get-configuration/actions'

export default function WDateDurationField({data, onChange, tabActive, selectedItems}) {
  const [entityObjects, entityObjectsDispatch] = useGetConfigurationReducer()
  const {configuration, reservation} = useContext(ReservationContext)
  const [fieldData, setFieldData] = useState({})
  const getConfigurationData = useCallback(() => {
    if (reservation?.selected_items?.length === 1) {
      if (Object.keys(fieldData).length === 0) {
        getConfiguration(
          entityObjectsDispatch,
          {group_id: configuration.data.entity_id},
          reservation?.selected_items[0].id
        ).then(res => {
          const resArr = res?.data?.duration_field_value?.map(value => {
            if (data?.id === JSON.parse(value.id)) {
              setFieldData({...fieldData, defaultValue: value.duration_value})
              const e = {
                target: {
                  value: value.duration_value,
                },
              }
              const val = {
                key: data?.key,
                value: value.duration_value,
              }
              onChange(e, 'value', val)
            }
          })
          setFieldData(resArr)
        })
      }
    }
  }, [
    configuration.data.entity_id,
    data?.id,
    data?.key,
    entityObjectsDispatch,
    fieldData,
    onChange,
    reservation?.selected_items,
  ])

  useEffect(() => {
    getConfigurationData()
  }, [getConfigurationData])

  return (
    <FormControl fullWidth variant="outlined" className="ap-textfield" style={{width: 320}}>
      <TextField
        id="outlined-adornment-amount"
        type={'text'}
        labelWidth={60}
        label={data.name}
        value={fieldData?.defaultValue ?? null}
        variant="outlined"
        InputLabelProps={{
          shrink: true,
        }}
        disabled
      />
    </FormControl>
  )
}
